import { request } from '@/utils/request';

export const getAlphabets = (params: any) => {
  return request('/v1/multilingual/aphabet_resources', { params });
  // return request('/v1/aphabet_translation_resources', { params });
};
